const Storage = {

    getItem(name) {
        try {
            const serializedState = localStorage.getItem(name);
            if (serializedState === null) {
                return undefined;
            }
            return JSON.parse(serializedState);
        }
        catch (err) {
            return undefined;
        }
    },

    removeItem(name) {
        localStorage.removeItem(name);
    },

    removeSessionItem(name) {
        sessionStorage.removeItem(name);
    },

    removeSessionItems(names) {
      names.forEach(name => this.removeSessionItem(name));
    },

    setItem(name, value) {
        try {
            const serializedState = JSON.stringify(value);
            localStorage.setItem(name, serializedState);
        }
        catch (err) {
            // Ignore write errors
        }
    },

    setSessionItem(name, value) {
      try {
        const serializedState = JSON.stringify(value);
        sessionStorage.setItem(name, serializedState);
      }
      catch (err) {
        // Ignore write errors
      }
    },

    getSessionItem(name) {
      try {
        const serializedState = sessionStorage.getItem(name);
        if (serializedState === null) {
          return undefined;
        }
        return JSON.parse(serializedState);
      }
      catch (err) {
        return undefined;
      }
    },

    getConnectedTokenExpiration(){
      return this.getSessionItem('connected-token-expiration');
    },

    customerLogout() {
      this.removeSessionItem('connected-token-expiration');
      this.removeSessionItem('connected-token');
      this.removeSessionItem('connected-refresh-token');
      this.removeSessionItem('token');
      this.removeSessionItem('user');
    },

};

export default Storage;
